(
    function (skyward, $, undefined)
    {
        // session - client-server 'state exchange' (ajax) object 
        skyward.session = skyward.session || {};
        var enabled = false;
        skyward.session.enabled = function ()
        {
            return enabled;
        };

        var postTimer;
        var defaultPostInterval = 5000;
        var postInterval = defaultPostInterval;
        var currentState = "Active";

        var noticeBarContainer = $(".systemwideMessageBar");

        var systemNoticeBar = noticeBarContainer.find("#systemNoticeNoticeBar");
        var hasSeenUpdateMessage = systemNoticeBar.data("hasseenupdatemessage") || false;
        var lockTime = getLockTime(systemNoticeBar);
        var countdownTimer;

        var environmentPurposeBar = noticeBarContainer.find("#environmentPurposeNoticeBar");
        var trainingModeBar = noticeBarContainer.find("#trainingModeNoticeBar");
        var alteredTimeBar = noticeBarContainer.find("#alteredTimeNoticeBar");

        var decrementRemainingSecondsUntilLock = function()
        {
            clearTimeout(countdownTimer);
            if (lockTime)
            {
                $(systemNoticeBar).find(".lockCountdown").html(skyward.time.getDisplayTimespan(lockTime - skyward.time.now()));

                updateNoticebar(systemNoticeBar, { html: $(systemNoticeBar).html() });
                countdownTimer = setTimeout(decrementRemainingSecondsUntilLock, 1000);
            }
        };
        countdownTimer = setTimeout(decrementRemainingSecondsUntilLock, 1000);

        skyward.session.currentState = function ()
        {
            return currentState;
        };

        var lastTransmissionNumber = 0;

        skyward.session.enable = function (interval)
        {
            if (postTimer)
            {
                clearTimeout(postTimer);
            }

            postInterval = interval || defaultPostInterval;
            currentState = "Inactive";
            postTimer = setTimeout(skyward.session.postState, postInterval);
            enabled = true;
        };

        skyward.session.disable = function ()
        {
            clearTimeout(postTimer);
            enabled = false;
        };

        skyward.session.setState = function (newState)
        {
            if (enabled && newState)
            {
                currentState = newState;
            }
        };

        skyward.session.postState = function (state)
        {
            clearTimeout(postTimer);
            if (currentState == "ClientTimedOut_Posted")
            {
                return;
            }

            currentState = state || currentState;
            lastTransmissionNumber++;
            if (currentState == "Active")
            {
                $.ajax({
                    url: skyward.global.virtualDir + "Security/Session/Active",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: { transmissionNumber: lastTransmissionNumber, hasSeenUpdateMessage: hasSeenUpdateMessage },
                    global: false,
                    success: handleSessionPingResponse,
                    error: function () { sessionHasEnded(null, null, "ServerError") }
                });
            }
            else if (currentState == "Inactive")
            {
                $.ajax({
                    url: skyward.global.virtualDir + "Security/Session/Inactive",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: { transmissionNumber: lastTransmissionNumber, hasSeenUpdateMessage: hasSeenUpdateMessage },
                    global: false,
                    success: handleSessionPingResponse,
                    error: function () { sessionHasEnded(null, null, "Inactive") }
                });
            }
            else if (currentState == "ClientTimedOut")
            {
                // This prevents double-posts by stopping any additional timers in idleMonitor.ts
                skyward.idleMonitor.disable();

                $.ajax({
                    url: skyward.global.virtualDir + "Security/Session/ClientTimedOut",
                    type: "POST",
                    activityIndicator: { silent: true },
                    data: { transmissionNumber: lastTransmissionNumber },
                    global: false,
                    success: function () {
                        if (!skyward.global.mobileAccess)
                        {
                            sessionHasEnded(null, null, "TimedOut");
                        }
                    },
                    error: function () {
                        if (!skyward.global.mobileAccess)
                        {
                            sessionHasEnded(null, null, "TimedOut");
                        }
                    }
                });
                return;
            }
            postTimer = setTimeout(skyward.session.postState, postInterval);
            currentState = "Inactive";
        };

        function sessionHasEnded(data, requestStatus, htmlErrorText)
        {
            skyward.window.skipUnloadCheck = true;
            window.location.href = skyward.global.virtualDir + "Security/SignIn/NotAuthenticated?status=" + htmlErrorText + "&cont=" + encodeURIComponent(window.location.href);
        }

        function handleSessionPingResponse(data)
        {
            if (data.transmissionNumber < lastTransmissionNumber)
            {
                return;
            }
            if (data.status != "Active")
            {
                if (!skyward.global.mobileAccess)
                {
                    sessionHasEnded(null, null, data.status);
                }
            }

            var utcDate = data.utcLockTime;
            lockTime = utcDate != null ? new Date(utcDate) : null;
            hasSeenUpdateMessage = data.hasSeenUpdateMessage;
            if (data.lockMessageContent)
            {
                var barContent = $("<div />").html(data.lockMessageContent.html);
                barContent.find(".lockCountdown").html(skyward.time.getDisplayTimespan(lockTime - skyward.time.now()));
                updateNoticebar(systemNoticeBar, { html: barContent.html() });
            }
            else
            {
                updateNoticebar(systemNoticeBar);
            }
            updateNoticebar(trainingModeBar, data.trainingMode ? { html: "System is in Training Mode" } : undefined);
            updateNoticebar(alteredTimeBar, data.trainingTimeOffset != null ? { html: "System time has been altered" } : undefined);
            displayAlteredTime();
            updateNoticebar(environmentPurposeBar, data.environmentPurpose);

            if (data.lockMessageContent)
            {
                if (lockTime != null)
                {
                    clearTimeout(countdownTimer);
                    countdownTimer = setTimeout(decrementRemainingSecondsUntilLock, 1000);

                    if (!hasSeenUpdateMessage)
                    {
                        var options = { closeOnClick: false, closeOnEscape: false };
                        var contents = function ()
                        {
                            hasSeenUpdateMessage = true; //todo: send to save immediately instead?
                            var result = $("<div />").html(systemNoticeBar.html());
                            setInterval(function ()
                            {
                                result.html(systemNoticeBar.html());
                            }, 1000);
                            return result;
                        };

                        var updatePendingModal = skyward.modalLayer.showDialog(
                            "Update Pending",
                            contents,
                            [{ text: "Sign Out Now", click: function () { updatePendingModal.close(); skyward.window.loadContent('full', 'security', 'SignIn', 'index', null, undefined); }, icon: "SignOut" }, { text: "Keep Working", click: "close", icon: "SignIn" }],
                            options);
                    }
                }
                skyward.session.enable(10000);
            }

            if (!skyward.global.mobileAccess)
            {
                skyward.idleMonitor.startWarningTimers(data.offset);
            }

            skyward.time.setCurrentTime(data.currentTime);
        }

        var timerForAlteredTime = null;
        function displayAlteredTime()
        {
            alteredTimeBar.html("<span>System time has been altered; the effective time is <span id='alteredTimeBarTimeDisplay'></span></span>");

            if (timerForAlteredTime != null)
            {
                clearTimeout(timerForAlteredTime);
                timerForAlteredTime = null;
            }
            if (alteredTimeBar.is(":visible"))
            {
                var displayElement = $("#alteredTimeBarTimeDisplay");
                var updateDisplay = function ()
                {
                    displayElement.html(skyward.time.now().toLocaleString());
                };
                updateDisplay();
                timerForAlteredTime = setInterval(updateDisplay, 1000);
            }
        }

        function updateNoticebar(message, args)
        {
            if (args)
            {
                message.html(args.html);
                message.css(args.css || {});
                message.addClass("noticeBar");
                message.removeClass("noticeBar--hidden");
            }
            else
            {
                message.addClass("noticeBar--hidden");
            }
        }

        function getLockTime(noticeBar)
        {
            var data = noticeBar.data();
            if (!data)
            {
                return null;
            }
            var date = data.utcLockTime;
            return date ? new Date(date) : null;
        }

        $(function ()
        {
            displayAlteredTime();

            if (systemNoticeBar.length && systemNoticeBar[0].hasAttribute("data-locktime"))
            {
                skyward.session.postState();
            }
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);